import { render, staticRenderFns } from "./BulkSMS.vue?vue&type=template&id=1643068a&scoped=true&"
import script from "./BulkSMS.vue?vue&type=script&lang=js&"
export * from "./BulkSMS.vue?vue&type=script&lang=js&"
import style0 from "./BulkSMS.vue?vue&type=style&index=0&id=1643068a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643068a",
  null
  
)

export default component.exports